
import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface PricingFeatureProps {
  title: string;
  icon: React.ReactNode;
  features: string[];
  isLocked?: boolean;
  isExpanded: boolean;
  onToggle: () => void;
  variant?: 'default' | 'pro';
}

export function PricingFeatureSection({
  title,
  icon,
  features,
  isLocked,
  isExpanded,
  onToggle,
  variant = 'default'
}: PricingFeatureProps) {
  const isPro = variant === 'pro';
  
  return (
    <div 
      className="group cursor-pointer"
      onClick={onToggle}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={cn(
            "h-6 w-6 rounded-full flex items-center justify-center",
            isLocked ? "bg-gray-100" : isPro ? "bg-[#818CF8]/10" : "bg-blue-50"
          )}>
            {icon}
          </div>
          <span className={cn(
            isLocked ? "text-gray-500" : isPro ? "text-white" : "text-gray-900"
          )}>{title}</span>
        </div>
        {isExpanded ? 
          <ChevronDown className={cn("h-4 w-4", isPro ? "text-gray-500" : "text-gray-400")} /> :
          <ChevronRight className={cn("h-4 w-4", isPro ? "text-gray-500" : "text-gray-400")} />
        }
      </div>
      {isExpanded && !isLocked && (
        <div className="mt-3 pl-9 space-y-2">
          {features.map((feature, index) => (
            <p key={index} className={cn(
              "text-sm",
              isPro ? "text-gray-400" : "text-gray-600"
            )}>• {feature}</p>
          ))}
        </div>
      )}
    </div>
  );
}
